import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ButtonComponent } from 'ui-library';

@Component({
  selector: 'app-risk-report',
  imports: [
    TranslateModule,
    MatDialogModule,
    FormsModule,
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatListModule,
    MatChipsModule,
    MatFormFieldModule,
    ButtonComponent
  ],
  templateUrl: './risk-report.component.html',
  styleUrls: ['./risk-report.component.scss']
})

export class RiskReportComponent {
  reportType = "";
  comment = "";
  reportTypeLabels: Record<string, string> = {};

  constructor(
    public dialogRef: MatDialogRef<RiskReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService) {
    this.comment = data.comment;
    this.reportTypeLabels = {
      'not_clear': this.translate.instant('risks.not_clear'),
      'not_pixelized': this.translate.instant('risks.not_pixelized'),
      'other': this.translate.instant('risks.other'),
    };
  }

  dismiss(): void {
    this.data.dismissed = true
    this.dialogRef.close();
  }

  ok(): void {
    if (this.reportType != "other") {
      this.comment = this.reportTypeLabels[this.reportType] as string;
    }

    this.dialogRef.close({
      comment: this.comment,
      status: this.reportType,
      ok: true
    });
  }
}
